var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "slider", staticClass: "slider" },
    _vm._l(_vm.counts, function(count, job_title) {
      return _c("div", { key: job_title, staticClass: "w-[280px] h-[280px]" }, [
        _c(
          "div",
          {
            staticClass:
              "bg-white w-full h-full flex flex-col items-center justify-center"
          },
          [
            _c("div", { staticClass: "text-150 text-orange font-extraBold" }, [
              _vm._v(_vm._s(count))
            ]),
            _vm._v(" "),
            job_title
              ? _c("div", {
                  staticClass: "text-20 font-medium text-brown-400 text-center",
                  domProps: { innerHTML: _vm._s(job_title) }
                })
              : _c(
                  "div",
                  {
                    staticClass:
                      "text-20 font-medium text-brown-400 text-center"
                  },
                  [_vm._v("Andere")]
                )
          ]
        )
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }